import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { Label } from "../../forms/Label/Label";
import { Select, TSelectOption } from "../../forms/Select";
import { TAgentAchievement } from "@/api/agent-performance/agent-performance.types";

type TAchievementDropdownProps = {
  isLoading?: boolean;
  selVal?: string;
  onAchievementSel: (value: string) => void;
  achievementData?: TAgentAchievement[];
};

const AchievementDropdown = ({
  selVal,
  onAchievementSel,
  achievementData,
  isLoading,
}: TAchievementDropdownProps) => {
  const { t } = useTranslation(["common"]);

  const transformedValues = useMemo(() => {
    return (
      achievementData?.map((item) => ({
        value: item?.name,
        label: item.title
          ?.split("_")
          ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
      })) ?? []
    );
  }, [achievementData]);

  return (
    <>
      <Label weight="medium" htmlFor="Achievement">
        {t("FILTER.ACHIEVEMENT", {
          defaultValue: "Achievement",
        })}
      </Label>

      <Select
        name="Achievement"
        isLoading={isLoading}
        options={transformedValues}
        value={transformedValues.find((opt) => opt.value === selVal) ?? null}
        onChange={(option: TSelectOption | null) => {
          onAchievementSel(option?.value ?? "");
        }}
        getOptionLabel={(option: TSelectOption) => option.label}
        getOptionValue={(option: TSelectOption) => option.value}
        placeholder={t("FILTER.ACHIEVEMENT", {
          defaultValue: "Achievement",
        })}
        isClearable={false}
      />
    </>
  );
};

export default AchievementDropdown;
